export const PROGRAM_ERROR_MESSAGES = {
  NO_DATA_IN_EPG: 'No data found in epg',
};
